import { IonButton } from "@ionic/react";
import React, { useEffect, useState } from "react";

export const Resultado = (props: { eneatype: number }) => {
  const [publicidad, setPublicidad] = useState<boolean>(false);
  const [mostrar, setMostrar] = useState<boolean>(false);
  const srcImg = process.env.PUBLIC_URL + "/imgs/ENEATEST_GRANDE.jpg";

  useEffect(() => {
    if (!publicidad) {
      setTimeout(() => {
        setPublicidad(true);
      }, 5000);
    }
  });

  var publicidadSection = (
    <section>
      <h1>Calculando resultado...</h1>
      {!publicidad ? (
        <h5>Calculando resultado por favor espere</h5>
      ) : (
        <IonButton onClick={() => setMostrar(true)}>Ver resultado</IonButton>
      )}
    </section>
  );

  var resultadoSection = (
    <section style={{ textAlign: "center" }}>
      <img style={{ width: "100vh" }} src={srcImg} alt="logo" />
      <h1>
        <p>
          Te hemos enviado un correo a tu dirección con el resultado del test
        </p>{" "}
        <p>Esperamos que sea de ayuda</p>
      </h1>
    </section>
  );

  return mostrar ? resultadoSection : publicidadSection;
};
